import { render, staticRenderFns } from "./CancelSubmitForm2.vue?vue&type=template&id=103ce188&scoped=true"
import script from "./CancelSubmitForm2.vue?vue&type=script&lang=ts"
export * from "./CancelSubmitForm2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103ce188",
  null
  
)

export default component.exports